import React from 'react';

type CoinDepositIconProps = {
  width?: number;
  height?: number;
  color?: string;
};

export const CoinDepositIcon = ({
  width = 14,
  height = 14,
  color = 'currentColor',
}: CoinDepositIconProps): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 14 14'
    fill='none'
    stroke={color}
    strokeWidth='0.88'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Coin Deposit Icon</title>
    <path d='M3.7207 5.63298H10.2807M7.0007 0.849976C7.55466 0.850066 8.09675 1.01047 8.56156 1.31183C9.02636 1.61319 9.39403 2.04262 9.62018 2.54831C9.84633 3.054 9.9213 3.61433 9.83604 4.16169C9.75078 4.70904 9.50894 5.22003 9.1397 5.63298H4.8607C4.49141 5.21996 4.24955 4.70889 4.16433 4.16144C4.07911 3.614 4.15416 3.05358 4.38043 2.54786C4.6067 2.04213 4.97452 1.61271 5.43948 1.31142C5.90444 1.01014 6.44666 0.849873 7.0007 0.849976Z' />
    <path d='M11.1005 4.13H11.1275C11.3575 4.13 11.5625 4.274 11.6415 4.49L12.6035 7.137H1.39746L2.35946 4.49C2.39784 4.38451 2.46775 4.29337 2.5597 4.22897C2.65166 4.16456 2.7612 4.13001 2.87346 4.13H2.90046' />
    <path d='M1.39746 7.13696V12.603C1.39746 12.905 1.64146 13.15 1.94346 13.15H12.0575C12.2024 13.1497 12.3412 13.092 12.4436 12.9894C12.546 12.8868 12.6035 12.7479 12.6035 12.603V7.13696' />
    <path d='M5.63379 10.416L7.00079 11.784L8.36779 10.417M7.00079 11.783V8.50298M7.54779 2.76298H6.72479C6.62971 2.76236 6.53742 2.79504 6.46392 2.85535C6.39043 2.91567 6.34036 2.99981 6.32243 3.09319C6.30449 3.18656 6.31981 3.28326 6.36572 3.36652C6.41164 3.44977 6.48525 3.51433 6.57379 3.54898L7.42779 3.89098C7.51633 3.92563 7.58994 3.99019 7.63586 4.07344C7.68177 4.1567 7.69709 4.2534 7.67915 4.34677C7.66121 4.44014 7.61115 4.52429 7.53766 4.58461C7.46416 4.64492 7.37187 4.6776 7.27679 4.67698H6.45379M7.00079 2.76298V2.21698M7.00079 5.22298V4.67698' />
  </svg>
);
